<template>
  <base-header type="" class="pt-4">
    <h1 class="d-f-1 mb-4">Meta Market</h1>
    <el-card class="dg-card">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h2 class="fw-7 d-g1 fs-28" style="padding: 3% 0">Coming Soon...</h2>
          </div>
        </div>
      </div>
    </el-card>
  </base-header>
</template>

<script>
export default {
  name: "metamarket",
  components: {},
};
</script>

<style scoped>
.big-head {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 34px;
  line-height: 36px;
  letter-spacing: -0.02em;
  color: #2c2d2f;
}
</style>
